import { makeAutoObservable } from 'mobx';
import { Products } from '../../config/Constants';
import { GroupStore } from './GroupStore';

export class NavigationStore {
  private current: Products = null;
  private GroupStore: GroupStore = null;

  constructor(groupStore: GroupStore) {
    makeAutoObservable(this);
    this.GroupStore = groupStore;
  }

  set currentProduct(p: Products) {
    this.current = p;
  }

  get currentProduct() {
    if (this.current === null && this.GroupStore.currentGroup) {
      const group = this.GroupStore.currentGroup;

      if (group.hasBalancer) return Products.LOAN_ACCOUNT;
      if (group.hasRecharger) return Products.RECHARGER;
      if (group.hasBrag) return Products.BRAG;
    }

    return this.current;
  }
}
